var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "pt-3 l-m-b-20 align-items-center d-flex justify-content-between blocks"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.$_can("carriers.roles.store")
                ? _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        to: "/settings/user-roles/create",
                        tag: "button"
                      }
                    },
                    [_vm._v("\n        ADD USER ROLE\n      ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      !_vm.roles
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "blocks" },
              _vm._l(_vm.roles, function(role, index) {
                return _c("SettingsUserRolesBlock", {
                  key: index,
                  attrs: { role: role },
                  on: {
                    "update:role": function($event) {
                      role = $event
                    }
                  }
                })
              })
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row blocks" },
              [
                _vm.meta.total
                  ? _c(
                      "div",
                      { staticClass: "col-sm-6 mb-1 text-black-50 pl-0" },
                      [
                        _vm._v(
                          "\n        Showing " +
                            _vm._s(_vm.meta.from) +
                            " - " +
                            _vm._s(_vm.meta.to) +
                            " of " +
                            _vm._s(_vm.meta.total) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1 pr-0",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("h1", { staticClass: "pr-3" }, [_vm._v("User roles")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8140ad4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8140ad4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/UserRoles/SettingsUserRoles.vue
// module id = null
// module chunks = 